import { mount } from '../../bootstrap';
import App from './App';

mount(App);
